uniform vec2 resolution;
uniform float devicePixelRatio;
uniform float time;
varying vec2 vUv;

#pragma glslify: isWithinRangeSmoothed = require(../../shaders/is-within-range-smoothed) 

float sdBox(in vec2 p, in vec2 b) {
    vec2 d = abs(p) - b;
    return length(max(d, 0.0)) + min(max(d.x, d.y), 0.0);
}

float sdCircle(vec2 p, float r) {
    return length(p) - r;
}

mat2 rotate2d(float _angle) {
    return mat2(cos(_angle), -sin(_angle), sin(_angle), cos(_angle));
}

// Adapted from: https://www.shadertoy.com/view/ttcyRS

vec3 oklabMix(vec3 colA, vec3 colB, float h) {

    // from SRGB to Linear: this isn't needed in 
    // three.js because we are already in linear (I think!)
    // colA = pow(colA,vec3(2.2));
    // colB = pow(colB,vec3(2.2));

    // https://bottosson.github.io/posts/oklab
    const mat3 kCONEtoLMS = mat3(0.4121656120, 0.2118591070, 0.0883097947, 0.5362752080, 0.6807189584, 0.2818474174, 0.0514575653, 0.1074065790, 0.6302613616);
    const mat3 kLMStoCONE = mat3(4.0767245293, -1.2681437731, -0.0041119885, -3.3072168827, 2.6093323231, -0.7034763098, 0.2307590544, -0.3411344290, 1.7068625689);

    // rgb to cone (arg of pow can't be negative)
    vec3 lmsA = pow(kCONEtoLMS * colA, vec3(1.0 / 3.0));
    vec3 lmsB = pow(kCONEtoLMS * colB, vec3(1.0 / 3.0));
    // lerp
    vec3 lms = mix(lmsA, lmsB, h);
    // gain in the middle (no oaklab anymore, but looks better?)
//  lms *= 1.0+0.2*h*(1.0-h);
    // cone to rgb
    vec3 linearOut = kLMStoCONE * (lms * lms * lms);

    // approx linear to srgb (linear to gamma really)
    //return pow(linearOut,vec3(1.0/2.2) );
    return linearOut;
}

// mat2 inverse(mat2 m) {
//   return mat2(m[1][1],-m[0][1],
//              -m[1][0], m[0][0]) / (m[0][0]*m[1][1] - m[0][1]*m[1][0]);
// }

float split = 0.5;

vec3 box(vec3 color, vec2 p, vec3 boxColor, float boxSize) {
    float boxDist = sdBox(p, vec2(190.0, 240.0));
    float boxDelta = fwidth(boxDist);
    vec2 bOffset = vec2(cos(time * 0.001) * 400.0, sin(time * 0.001) * 400.0);
    p -= bOffset;
    float distanceFromBlurCircle = sdCircle(p, boxSize);
    p += bOffset;

    // remove abs to see the shape causing the effect
    float isBox = smoothstep(abs(distanceFromBlurCircle) + boxDelta, 0.0, boxDist);
    vec3 okLabColor = oklabMix(color, boxColor, isBox);
    vec3 mixedColor = mix(color, boxColor, isBox);
    return mix(okLabColor, mixedColor, step(split, vUv.y));
}

void main() {
    vec2 st = gl_FragCoord.xy / resolution.xy / devicePixelRatio;

    vec2 userResolution = resolution.xy / devicePixelRatio;
    vec2 p = vUv * userResolution;

    vec3 color = vec3(0.0);

    // Centre relative
    p -= userResolution / 2.0;

    color = box(color, p, vec3(0.28, 0.69, 0.93), 100.0);

    mat2 rotate;

    vec2 offset = vec2(sin(time * 0.001) * 100.0, sin(time * 0.001) * -180.0);

    p += offset;
    rotate = rotate2d(time * 0.0003);
    p = rotate * p;
    color = box(color, p, vec3(0.25, 0.75, 0.58), 100.0);
    p = inverse(rotate) * p;

    p -= offset;

    p += offset;
    rotate = rotate2d(time * 0.0003);
    p = rotate * p;
    color = box(color, p, vec3(0.92, 0.55, 0.36), 50.0);
    p = inverse(rotate) * p;
    p -= offset;

    p *= 0.8;

    // Circle
    vec2 circleOffset = vec2(10.0, 10.0);
    p += circleOffset;
    vec3 circleColor = vec3(0.88, 0.51, 0.74);
    float cicleDistance = sdCircle(p, 100.0);
    float cicleDelta = fwidth(cicleDistance);
    offset = vec2(sin(time * 0.001) * 50.0, cos(time * 0.001) * 40.0);
    p -= offset;
    float distanceFromBlurCircle = sdCircle(p, 50.0);
    p += offset;
    float isCircle = smoothstep(abs(distanceFromBlurCircle) + cicleDelta, 0.0, cicleDistance);


    //color = oklabMix(color, circleColor, isCircle);
    vec3 okLabColor = oklabMix(color, circleColor, isCircle);
    vec3 mixedColor = mix(color, circleColor, isCircle);
    color =  mix(okLabColor, mixedColor, step(split, vUv.y));

    p -= circleOffset;

    // Bottom left relative
    p += userResolution / 2.0;

    // Circle

    // Border
    // vec3 borderColor = vec3(0.98, 0.98, 0.82);
    // float borderThickness = 20.0;
    // float isBorder = isWithinRangeSmoothed(p, vec2(borderThickness), vec2(userResolution - borderThickness), 0.01);
    // color = mix(color, borderColor, 1.0 - isBorder);

    gl_FragColor = vec4(color, 1.0);
}